const ADMIN_CREDENTIALS = {
  username: 'admin',
  password: 'ensureDaily@2025'
};

const updatesCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const previewCache = new Map();
const PREVIEW_CACHE_SIZE = 5;
const filePreviewCache = new Map();

export const validateAdminCredentials = (username, password) => {
  return username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password;
};

export const fetchDailyUpdates = async () => {
  try {
    // Check cache first
    const cached = updatesCache.get('dailyUpdates');
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      return cached.data;
    }

    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/content/daily`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (!response.ok) throw new Error('Failed to fetch updates');

    const files = await response.json();
    const jsonFiles = files
      .filter(file => file.name.endsWith('.json'))
      .sort((a, b) => b.name.localeCompare(a.name));

    // Cache the results
    updatesCache.set('dailyUpdates', {
      data: jsonFiles,
      timestamp: Date.now()
    });

    return jsonFiles;
  } catch (error) {
    console.error('Error fetching daily updates:', error);
    return [];
  }
};

export const fetchFileContent = async (path) => {
  try {
    // Return cached content immediately if available
    if (filePreviewCache.has(path)) {
      return filePreviewCache.get(path);
    }

    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${path}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (!response.ok) throw new Error('Failed to fetch file content');

    const data = await response.json();
    const content = JSON.parse(atob(data.content));

    // Cache the content permanently
    filePreviewCache.set(path, content);

    // Preload next file in background
    prefetchNextFile(path);

    return content;
  } catch (error) {
    console.error('Error fetching file content:', error);
    throw error;
  }
};

const prefetchNextFile = async (currentPath) => {
  const files = await fetchDailyUpdates();
  const currentIndex = files.findIndex(f => f.path === currentPath);
  if (currentIndex >= 0 && currentIndex < files.length - 1) {
    const nextFile = files[currentIndex + 1];
    if (!filePreviewCache.has(nextFile.path)) {
      fetchFileContent(nextFile.path).catch(() => {}); // Silently fail preloading
    }
  }
};

export const clearCache = () => {
  updatesCache.clear();
};